/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemEditViewFromController(
    this: JS5Object,
    _: JS5Object,
    EnumService: JS5Object,
    $routeParams: JS5Object
) {
    const setVisibleFormControls = (type: string) => {
        switch (type) {
            case 'Video':
                this.visibleFormControls = {
                    deliveryMode: true,
                    languages: this.editData.mode === 'DUB_CARDS',
                };
                break;

            case 'Audio':
                this.visibleFormControls = {
                    languages: true,
                    profile: true,
                    roles: true,
                };
                break;

            case 'Artwork':
                this.visibleFormControls = {
                    languages: true,
                    profile: true,
                };
                break;

            case 'Image':
                this.visibleFormControls = {
                    languages: true,
                    profile: true,
                };
                break;

            case 'CC':
                this.visibleFormControls = {
                    deliveryMode: true,
                    languages: true,
                    roles: true,
                };
                break;

            case 'Subtitle':
                this.visibleFormControls = {
                    deliveryMode: true,
                    languages: true,
                    roles: true,
                };
                break;

            case 'Metadata':
            case 'Archive':
                this.visibleFormControls = {};
                break;

            default :
                this.visibleFormControls = null;
                console.warn(`Unknown delivery item type [${this.editData.type}] when setting visibly form controls `);
                break;
        }
    };

    const requiredFormControls = {
        deliveryMode: ['Video']
    };

    this.isFieldRequired = (formControlName: string) => {
        return _.chain(requiredFormControls)
            .get(formControlName, [])
            .includes($routeParams.deliveryItemType)
            .value();
    };

    const getFormData = () => {
        switch (this.editData.type) {
            case 'Video':
                this.deliveryModes = EnumService.getEnumPicklist('VideoDeliveryItem_mode');
                break;

            case 'Subtitle':
            case 'CC':
                this.deliveryModes = EnumService.getEnumPicklist('TextDeliveryItem_mode');
                break;

            default:
                break;
        }
    };

    this.transformDeliveryModeLabel = (item: JS5Object) => {
        return `${this.editData.type} - ${item.displayName}`;
    };

    this.handleDeliveryConditionTemplateChange = () => {
        if (this.deliveryConditions != null) {
            this.editData.deliveryConditions = [this.deliveryConditions]
        } else {
            this.editData.deliveryConditions = [];
        }
    };

    const setDeliveryConditions = () => {
        if (_.size(this.editData.deliveryConditions)) {
            this.deliveryConditions = _.first(this.editData.deliveryConditions)
        } else {
            this.deliveryConditions = null;
        }
    };

    this.$onInit = () => {
        if (this.editData.sourceType == 'ARTWORK_IMAGE') {
            this.mediaAcceptProfiles = _.filter(this.mediaAcceptProfiles, {type: 'OTHER'});
        } else {
            this.mediaAcceptProfiles = _.filter(this.packageAcceptTemplate.mediaAcceptProfiles, {type: _.toUpper(this.editData.type)});
        }
        EnumService.queryForEnums().then(() => {
            setVisibleFormControls($routeParams.deliveryItemType);
            getFormData();
            setDeliveryConditions();

            let defaultModeId = _.chain(this.deliveryModes)
                .find({id: 'DEFAULT'})
                .get('id')
                .value();
            if (!this.editData.mode && defaultModeId) {
                this.editData.mode = defaultModeId;
            }
        });
    };

    this.$onChanges = () => {
        if (this.visibleFormControls !== undefined) {
            setDeliveryConditions();
        }
    };

    this.onDeliveryModeChanged = () => {
        setVisibleFormControls($routeParams.deliveryItemType);
    };

}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewFrom', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/from/delivery-items-edit-view-from-template.html',
    controller: DeliveryItemEditViewFromController,
    bindings: {
        editData: '<',
        languages: '<',
        roles: '<',
        packageAcceptTemplate: '<',
        mediaAcceptProfiles: '<',
        conditionalTemplates: '<'
    }
});
